export const styles = theme => ({
  header: {
    background: 'black',
    top: 0
  },
  tenantLink: {
    textDecoration: 'none',
    color: '#ce9568',
    '&:visited': {
      color: '#ce9568'
    }
  }
});
